import { Phone } from "lucide-react";
import { site } from "@/config/site";
import { useLeadForm } from "@/components/lead/LeadForm";
import { trackEvent } from "@/lib/tracking";
import { Reveal } from "@/components/site/Reveal";

export function CTASection({
  title = "Ready to Transform Your Windows?",
  text = "Book a free home design visit and let our specialists help you find the right style, colour and finish for your home.",
  primaryLabel,
  source = "cta_section",
}) {
  const { openForm } = useLeadForm();
  return (
    <section className="relative overflow-hidden bg-navy-950 grain" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 text-center relative">
        <Reveal>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-tight max-w-3xl mx-auto">
            {title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-white/70 max-w-2xl mx-auto leading-relaxed">
            {text}
          </p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              type="button"
              data-testid="cta-book-visit-btn"
              onClick={() => openForm({ source })}
              className="inline-flex items-center rounded-full bg-white px-8 py-4 text-sm font-semibold text-navy-900 shadow-xl transition-all duration-300 hover:-translate-y-0.5 hover:shadow-2xl"
            >
              {primaryLabel || site.primaryCTA}
            </button>
            <a
              href={site.phone.href}
              data-testid="cta-call-btn"
              onClick={() => trackEvent("phone_click", { location: source })}
              className="inline-flex items-center gap-2 rounded-full border border-white/30 px-8 py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-white/10"
            >
              <Phone className="h-4 w-4" /> Call Us — {site.phone.display}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
